import React from 'react';

export interface FormGroupProps {
	error?: string;
	children: React.ReactNode;
	className?: string;
}

/**
 * Wrapper that lays out a form field with an optional inline error message.
 *
 * Styling depends on consumer-side CSS classes: `auth-label`,
 * `auth-text-critical`. These must be defined by the host app.
 */
export const FormGroup: React.FC<FormGroupProps> = ({
	error,
	children,
	className = '',
}) => {
	return (
		<div className={`auth-label ${className}`}>
			{children}
			{error && <div className="auth-text-critical ">{error}</div>}
		</div>
	);
};
